import { set } from 'lodash';
import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

const YEAR = '2021';
/**
 * @param url
 * @param {Object} data
 * @param method
 * @param params - request params object
 * @returns {*}
 */
const request = (url, data, method = 'POST', params) => {
  return API.request({
    method,
    url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
    params,
  });
};

function getPropertyDeductionBalance() {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/property-deduction-balance`, {}, 'GET');
}

function remove3NDFLDraft(draftId) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/3NDFLDraft/delete/${draftId}`, {}, 'POST');
}

function get3NDFLDrafts(params) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/list`, undefined, 'GET', params);
}

function load3NDFLDraft(draftId) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${draftId}`, {}, 'GET');
}

function new3NDFLDraft(year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/new`, {}, 'GET');
}

function new3NDFLShortDraft(year, mode) {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/${year}/short/new`,
    params: { mode },
  });
}

function save3NDFLDraft(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/save`, data, 'POST');
}

function save3NDFLAsDraft(data, year = YEAR) {
  const stdDeductionChildren = data.getIn([
    'payload',
    'sheetE1',
    'userDeduction',
    'stdDeductionChildren',
  ]);
  if (stdDeductionChildren) {
    data = data.setIn(
      ['payload', 'sheetE1', 'userDeduction', 'stdDeductionChildren', 'modelVersion'],
      2018,
    );
  }
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/save`, data);
}

function create3NDFLXmlDraft(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/submit`, data);
}

function send3NDFLAppeal(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/xml`, data);
}

function get2NDFLByYear(year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/ndfl2/${year}`, {}, 'GET');
}

function getSocDeductionsBy2NDFL(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/socdeductions`, data);
}

/**
 *
 * @param {Object[]} data
 * @param year
 * @returns {*}
 */
function getStdDeductionsBy2NDFL(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/stdagentdata`, data);
}

function getChildDeductions(data) {
  const res = set(data, 'stdDeductionChildren.modelVersion', 2018);
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${data.reportYear}/childdeductions`, res);
}

function getMonthIncomes(data, year = YEAR) {
  return request(`/notification/${NDFL3_NOTIFICATION_ID}/${year}/monthincomes`, data);
}

export {
  getPropertyDeductionBalance,
  load3NDFLDraft,
  save3NDFLAsDraft,
  save3NDFLDraft,
  new3NDFLDraft,
  new3NDFLShortDraft,
  create3NDFLXmlDraft,
  send3NDFLAppeal,
  get3NDFLDrafts,
  remove3NDFLDraft,
  get2NDFLByYear,
  getSocDeductionsBy2NDFL,
  getStdDeductionsBy2NDFL,
  getChildDeductions,
  getMonthIncomes,
};
